import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import TalentDetails from './TalentDetails'
export default class Dashboard extends React.Component {

    render() {
        
       // let id = this.props.match.params.id;
       // let page = this.props.match.params.page;

        const urlParams = new URLSearchParams(window.location.search);
        return (
            <div className="wrapper">

                <Navbar />
                <Mainmenu />
                <TalentDetails urlParams={urlParams} />
                <Footer />

            </div>


        )
    }
}
